// components/Common/PublicRoute.jsx
import { useAuth } from '../../contexts/AuthContext';

const PublicRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  // IMPORTANT: Even if authenticated, show the public survey
  // Don't redirect to dashboard for public survey routes
  return children;
};

export default PublicRoute;